module.exports = __webpack_public_path__ + "static/media/example03-03.9315729c.svg";